module.exports = __webpack_public_path__ + "site/img/location.9d094361.svg";